import React from 'react';
import './buttonGallery.css';
const ButtonGallery = ({
  onClick,
  text,
  icon,
  type = 'button',
  width = '200px',
  height = '200px',
  msg,
  stylesError = null,
  disabled = false,
}) => {
  const stylesButtonGallery = {
    width: width,
    height: height,
  };
  return (
    <button
      onClick={onClick}
      type={type}
      className={`d-flex flex-column align-items-center justify-content-center p-4 buttonGallery ${
        stylesError && 'error'
      } ${disabled && 'disabled'}`}
      style={stylesButtonGallery}
      disabled={disabled}
    >
      <span className='mb-1 iconContainer'>{icon}</span>
      {text}
      <span style={{ fontSize: '12px' }}>{msg}</span>
    </button>
  );
};

export default ButtonGallery;
